import React, { useState } from 'react';

import { Button, Col } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { decode } from 'html-entities';

import { EyeIcon, TrashcanIcon } from 'assets/icons';
import { ReviewStepWrapperModal } from 'pages/Dashboard/GroupManagement/SmartEventsBuilder/Steps/Review';

import DeleteSmartEventsModal from './DeleteSmartEventsModal';

interface ISmartEventsProps {
  smartEvent: ICarePlanSmartAlert;
  onDeleteSmartEvent: (attribute: string) => any;
  carePlanTemplate?: ICarePlanTemplate;
  disabled?: boolean;
}

const SmartEvent = ({
  smartEvent,
  onDeleteSmartEvent,
  carePlanTemplate,
  disabled
}: ISmartEventsProps) => {
  const intl = useIntl();
  const [showViewModal, setShowViewModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const isTemplateGlobal = carePlanTemplate?.template_type === 'GLOBAL';

  return (
    <Col
      key={smartEvent.attribute_id}
      data-test={`careplan-smart-events-${smartEvent.attribute}`}
      lg={6}
      xl={4}
      className="mb-3"
    >
      <div className="bg-light">
        {!isTemplateGlobal && (
          <>
            <Button
              variant="link"
              className="float-right p-2 m-1"
              data-test={`careplan-smart-events-${smartEvent.attribute}-delete`}
              onClick={() => setShowDeleteModal(true)}
              disabled={disabled}
            >
              <TrashcanIcon className="icon" style={{ fontSize: '16px' }} />
            </Button>
            <Button
              variant="link"
              className="float-right p-2 m-1"
              data-test={`careplan-smart-events-${smartEvent.attribute}-view`}
              onClick={() => setShowViewModal(true)}
              disabled={disabled}
            >
              <EyeIcon className="icon" style={{ fontSize: '16px' }} />
            </Button>
          </>
        )}
        <div className="p-3 font-weight-bolder text-sm">
          {intl.formatMessage({ id: decode(smartEvent.summary) })}
        </div>
      </div>

      <DeleteSmartEventsModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        smartEvent={smartEvent}
        onDeleteSmartEvent={onDeleteSmartEvent}
        carePlanTemplate={carePlanTemplate}
      />
      {showViewModal && (
        <ReviewStepWrapperModal
          attribute={smartEvent.attribute}
          close={() => setShowViewModal(false)}
        />
      )}
    </Col>
  );
};

export default SmartEvent;
